import '../../styles/blocks/acf/email-support-faq.scss';

(function () {
const PLACEHOLDER_EMAIL = 'info@example.com';
const PLACEHOLDER_DOMAIN = 'example.com';

function applyEmailPersonalisation(answers, emailAddress) {
  const email = emailAddress || PLACEHOLDER_EMAIL;
  const website = email.replace(/.*@/, '');

  answers.forEach((answer) => {
    const original = answer.dataset.originalHtml ?? answer.innerHTML;
    let html = original.replaceAll(PLACEHOLDER_EMAIL, email);
    html = html.replaceAll(PLACEHOLDER_DOMAIN, website);
    answer.innerHTML = html;
  });
}

function filterByDevice(root, device) {
  const items = root.querySelectorAll('.email-support-faq__item');

  items.forEach((item) => {
    if (!device) {
      item.hidden = false;
      return;
    }

    const matches =
      item.classList.contains(`tag-${device}`);
      //|| item.classList.contains('tag-empty')

    item.hidden = !matches;
  });
}

function initEmailSupportFaq(root) {
  const answers = root.querySelectorAll('.email-support-faq__answer');
  answers.forEach((answer) => {
    answer.dataset.originalHtml = answer.innerHTML;
  });

  const deviceSelect = root.querySelector('[data-filter-device]');
  deviceSelect?.addEventListener('change', () => {
    filterByDevice(root, deviceSelect.value);
  });

  const emailInput = root.querySelector('[data-filter-email]');
  emailInput?.addEventListener('change', () => {
    applyEmailPersonalisation(answers, emailInput.value.trim());
  });
}

function boot() {
  document.querySelectorAll('[data-email-support-faq]').forEach(initEmailSupportFaq);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
})();
